import { fetchApiCall } from '../client';

const EMPTY_USER = { name: '', email: '', permissionGroup: null };

// Profile of the signed-in user from user_detail_view. Resolves undefined
// when there is no session to query with.
export const fetchUserDetails = async (auth, setAlert) => {
    if (!auth?.cls?.userEmail || !auth?.cls?.jwtToken) return;
    const result = await fetchApiCall('user_detail_view', auth, setAlert);
    const row = result.data?.[0];
    if (!row) return EMPTY_USER;
    return {
        firstName: row.first_name,
        lastName: row.last_name,
        email: row.user_email,
        login: row.login,
        isActive: row.is_active,
        permissionGroup: row.permission_group,
        userType: row.user_type,
        docuSignConnected: row.docusign_connected,
    };
};
